export default __webpack_public_path__ + "static/media/imgs2.b3ec0731.jpg";